import { ReactNode } from 'react';

export const BroadcastWebinarHeader = ({ children }: { children: ReactNode }) => (
    <header className="relative col-start-1 bc:col-span-3 row-start-1 bg-white flex flex-wrap justify-end bc:justify-between px-4 py-2">{children}</header>
);
